<template>
  <div
    class="fixed right-4 z-50 h-[97px] w-[202px] origin-bottom-right scale-[0.8] cursor-pointer"
    :style="{ bottom: `${bottomOffset}px` }"
    @click="handleBannerClick"
  >
    <img
      :src="earthSrc"
      alt=""
      role="presentation"
      class="absolute top-0 right-0 h-[97px] w-[97px] origin-center rounded-full transition-transform duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
      :class="isVisible ? 'scale-100' : 'scale-0'"
    />
    <div
      class="absolute top-0 left-0 origin-bottom-right transition-transform delay-[350ms] duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)]"
      :class="isVisible ? 'scale-100' : 'scale-0'"
    >
      <img
        :src="bubbleSrc"
        alt=""
        role="presentation"
        class="h-[46px] w-auto"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { freedomApp } from 'freedom-shared';

  import earthSrc from '../assets/traveler_banner_bg.webp';
  import bubbleEn from '../assets/traveler_banner_en.webp';
  import bubbleKk from '../assets/traveler_banner_kk.webp';
  import bubbleRu from '../assets/traveler_banner_ru.webp';

  type TravelerBannerLocale = 'ru' | 'kk' | 'en';

  const BUBBLE_BY_LOCALE: Record<TravelerBannerLocale, string> = {
    ru: bubbleRu,
    kk: bubbleKk,
    en: bubbleEn,
  };

  /** Delay before kicking off the appearance animation (lets the initial scale(0) paint). */
  const ANIMATION_START_DELAY = 50;

  withDefaults(
    defineProps<{
      /** Bottom offset in px. Pass 96 when the page renders a BottomNav tabbar. */
      bottomOffset?: number;
    }>(),
    {
      bottomOffset: 16,
    },
  );

  const { locale } = useI18n();

  const bubbleSrc = computed(() => {
    const currentLocale = locale.value as TravelerBannerLocale;
    return BUBBLE_BY_LOCALE[currentLocale] ?? BUBBLE_BY_LOCALE.ru;
  });

  const handleBannerClick = () => {
    const bannerHref = `https://freedomfinder.kz/?language=${encodeURIComponent(
      locale.value,
    )}`;
    freedomApp.lib.navigate(bannerHref);
  };

  const isVisible = ref(false);
  let animationTimeout: ReturnType<typeof setTimeout> | undefined;

  onMounted(() => {
    animationTimeout = setTimeout(() => {
      isVisible.value = true;
    }, ANIMATION_START_DELAY);
  });

  onBeforeUnmount(() => {
    clearTimeout(animationTimeout);
  });
</script>
